import React from "react";
import { Button, Tooltip } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { useSoListModel } from "../soListModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { IDescription, DescriptionColorEnum } from "@/components/YhBox/Types";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { disableExportMsg } from "@/utils/exportFile";

export const DataBox = () => {
    const { exportSoList, descTotal } = useSoListModel();

    const action = <>
        <YhAuth resCode={ResourceAuthEnum.STT_SL_EX}>
            <Tooltip placement="topLeft" title={disableExportMsg}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={() => exportSoList()}
                >导出</Button>
            </Tooltip>

        </YhAuth>
    </>;
    const desc: IDescription[] = [
        {
            label: "销售数量",
            value: descTotal.totalNum,
            color: DescriptionColorEnum.red
        },
        {
            label: "销售金额",
            value: descTotal.payAmount,
            color: DescriptionColorEnum.red
        },
        {
            label: "应收金额",
            value: descTotal.receivableAmount,
            color: DescriptionColorEnum.red
        },
        {
            label: "已收金额",
            value: descTotal.receivedAmount,
            color: DescriptionColorEnum.red
        },
        {
            label: "已付金额",
            value: descTotal.paidAmount,
            color: DescriptionColorEnum.red
        },
        {
            label: "销售成本",
            value: descTotal.costAmount,
            color: DescriptionColorEnum.red
        },
        {
            label: "销售毛利",
            value: descTotal.grossProfitAmount,
            color: DescriptionColorEnum.red
        },
    ]
    return (
        <YhBox action={action} style={{ height: 'calc(100vh - 180px)' }}>
            <DataTable />
        </YhBox>
    )
}